import { render, staticRenderFns } from "./recruitDemand.vue?vue&type=template&id=b6e542bc&scoped=true&"
import script from "./recruitDemand.vue?vue&type=script&lang=js&"
export * from "./recruitDemand.vue?vue&type=script&lang=js&"
import style0 from "./recruitDemand.vue?vue&type=style&index=0&id=b6e542bc&prod&scoped=true&lang=css&"
import style1 from "./recruitDemand.vue?vue&type=style&index=1&id=b6e542bc&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6e542bc",
  null
  
)

export default component.exports